var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-selection"},[_c('product-carousel'),_c('amount-picker',{staticClass:"product-selection__amounts"}),_c('vb-button',{staticClass:"product-selection__cta",attrs:{"vb_options":{
      text: `<strong>${_vm.cta_text}</strong>`,
      to: { name: 'checkout' },
      icon: 'g-card',
      variant: 'info',
      size: 'lg',
      block: true,
      disabled: !_vm.selected_amount,
    }}}),_c('p',{staticClass:"product-selection__note"},[_vm._v("Il pagamento sarà gestito con il tuo credito welfare aziendale")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }